var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlipVertical = function SvgFlipVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.708097 6.16264L6.84801 0.0227269L12.9929 6.16264H9.87074V11H3.82528V6.16264H0.708097ZM3.2983 5.14844H5.03835V9.9858H8.66264V5.14844H10.4027L6.84801 1.59375L3.2983 5.14844ZM16.2058 0.818182L19.0396 9.1108H19.1539L21.9877 0.818182H23.6483L19.9842 11H18.2093L14.5453 0.818182H16.2058Z",
    fill: "white"
  })));
};
export { SvgFlipVertical as ReactComponent };
export default __webpack_public_path__ + "assets/9fa3e8b1.svg";